import React from "react";

import cn from "./style.module.scss";

export function Title() {
  return <h3 className={cn.stepViewTitle}>STEPS COMPLETE!</h3>;
}
